module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIyNCIgaGVpZ2h0PSIyNCIgdmlld0JveD0iMCAwIDI0IDI0Ij4KICAgIDxnIGZpbGw9Im5vbmUiIGZpbGwtcnVsZT0iZXZlbm9kZCI+CiAgICAgICAgPHBhdGggZmlsbD0iI0ZGRiIgZmlsbC1vcGFjaXR5PSIwIiBkPSJNMCAwSDI0VjI0SDB6IiB0cmFuc2Zvcm09Im1hdHJpeCgxIDAgMCAtMSAwIDI0KSIvPgogICAgICAgIDxwYXRoIHN0cm9rZT0iIzY3NjM2MiIgc3Ryb2tlLWxpbmVjYXA9InJvdW5kIiBzdHJva2UtbGluZWpvaW49InJvdW5kIiBkPSJNMTQgOEwxMCAxMiAxNCAxNiIgdHJhbnNmb3JtPSJtYXRyaXgoMSAwIDAgLTEgMCAyNCkgbWF0cml4KDAgLTEgLTEgMCAyNCAyNCkiLz4KICAgIDwvZz4KPC9zdmc+Cg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon/arrow_up_black.svg
// module id = isiO
// module chunks = 30